import React, { useEffect } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import {
  Box,
  Typography,
} from '@mui/material';
import { RichTextField, useEditContext } from 'react-admin';
import { ICase } from '../../../utilities/schemas/case';
import useLoadingDots from '../../../hooks/useLoadingDots';
import getCaseDescriptionText from '../utils/description';

const CaseSummary = () => {
  const {
    record,
    refetch,
  } = useEditContext<ICase>();

  const {
    text,
    hasError,
    isPending,
    shouldShowSummary,
  } = getCaseDescriptionText(record?.aiSummary);

  useEffect(() => {
    if (isPending) {
      const interval = setInterval(() => {
        refetch();
      }, 1000);
      return () => clearInterval(interval);
    }

    return undefined;
  }, [isPending, refetch]);

  const { loadingDots, loadingDotsStyle } = useLoadingDots(isPending);

  const {
    abstract,
    generatedAt,
  } = record?.aiSummary ?? {};

  return (
    <>
      <Box display="flex" alignItems="center" rowGap={1} columnGap={2} marginBottom={3} flexWrap="wrap">
        <AutoAwesomeIcon color="ai" fontSize="small" />
        <Typography variant="h6">
          Summary
        </Typography>
        {generatedAt && (
          <Typography
            variant="caption"
            color="text.secondary"
          >
            Generated:
            {' '}
            {new Date(generatedAt).toLocaleString()}
          </Typography>
        )}
      </Box>
      {!shouldShowSummary && (
        <Typography>
          No AI summary available
        </Typography>
      )}
      {isPending && (
        <Typography sx={loadingDotsStyle}>
          {text}
          {loadingDots}
        </Typography>
      )}
      {hasError && (
        <Typography>
          {text}
        </Typography>
      )}
      {!isPending && !hasError && shouldShowSummary && (
        <>
          <Typography fontWeight="bold" gutterBottom>
            {text}
          </Typography>
          {abstract && (
            <RichTextField source="aiSummary.abstract" />
          )}
        </>
      )}
    </>
  );
};

export default CaseSummary;
